import { render, staticRenderFns } from "./DNSResolvers.vue?vue&type=template&id=010391d3&scoped=true&"
import script from "./DNSResolvers.vue?vue&type=script&lang=ts&"
export * from "./DNSResolvers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010391d3",
  null
  
)

export default component.exports